import { render, staticRenderFns } from "./Keys.vue?vue&type=template&id=f28196ea&scoped=true&"
import script from "./Keys.vue?vue&type=script&lang=js&"
export * from "./Keys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28196ea",
  null
  
)

export default component.exports